<template>
    <div>
        <b-form @submit.prevent="saveForm" @keydown.enter="saveForm">
            <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                <template slot="label">
                    <span v-translate>Recipients*</span>
                </template>
                <b-input-group>
                    <EmailFormInput ref="email_form_input" />
                </b-input-group>
            </b-form-group>
        
            <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                <template slot="label">
                    <span v-translate>Message</span>
                </template>
                <b-input-group>
                    <b-form-textarea id="input-2" v-model="sendDetails.message" :placeholder="$gettext('Dear...')" rows="6" />
                </b-input-group>
            </b-form-group>

            <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                <template slot="label">
                    <span v-translate>Attachments</span>
                </template>
                <div class="table-container">
                    <b-table 
                        :items="items"
                        :fields="fields"
                        class="document-table"
                        :class="['gk-table gk-table--responsive gk-table--hover']"
                        outlined
                        hover>

                        <template #cell(actions)="data">
                            <GekkoButton 
                                @click="removeDocumentFromList(data)"
                                icon="fa-solid fa-trash"
                                variant="link"
                                class="text-danger"/>
                        </template>
                    </b-table>
                </div>

                <div>
                    <div v-show="showDocumentSelector">
                        <DocumentSelector 
                            ref="document_selector"
                            @documentSelected="onDocumentSelected"/>
                    </div>

                    <GekkoButton 
                        v-if="!showDocumentSelector"
                        @click="addFile()"
                        :text="$gettext('Add another file')"
                        icon="fa-solid fa-plus"
                        variant="link"/>
                </div>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import DocumentService from "@/store/services/document.service";
import DocumentSelector from "@/components/documents/DocumentSelector";
import EmailFormInput from "@/components/ui/EmailFormInput";

export default {
    name: "AddEditDocument",
    components: {GekkoButton, DocumentSelector, EmailFormInput},
    data() {
        return {
            sendDetails: {
                emails: "",
                message: ""
            },
            showDocumentSelector: false,
            items: [],
            fields: [
                {key: "title", label: this.$gettext('Title')},
                {key: "description", label: this.$gettext('Description')},
                {key: "actions", label: "", tdClass: "text-right"}
            ]
        }
    },
    created() {
        if (this.$route.params['documentId']) {
            DocumentService.retrieve(this.$route.params['documentId']).then((response) => {
                this.items.push(response.data);
            });
        }
    },
    methods: {
        saveForm(ev) {
            if (ev && ev.key && ev.target.nodeName !== 'TEXTAREA') {
                ev.preventDefault()
                return
            }
            if (!ev || (ev && !ev.key)) { // avoid submitting on key events
                this.sendDetails.emails = this.$refs.email_form_input.getFullString();
                this.sendDetails.documents = this.items.map((item) => item.id);
                
                DocumentService.send(this.sendDetails).then((response) => {
                    if (response.status === 202) {
                        this.$router.push({name: "Documents"});
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Documents sent"),
                            text: this.$gettext("The documents were sent successfully."),
                            variant:"success",
                            duration: 4
                        });
                    }
                }).catch((error) => {
                    if (error && error.status === 400 && error.data && error.data.emails) {
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Error"),
                            text: error.data.emails[0],
                            variant:"danger",
                            duration: 4
                        });
                    } else {
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Error"),
                            text: this.$gettext("Error sending the documents."),
                            variant:"danger",
                            duration: 4
                        });
                    }
                });
            }
        },
        addFile() {
            this.showDocumentSelector = !this.showDocumentSelector;
        },
        onDocumentSelected(item) {
            this.showDocumentSelector = !this.showDocumentSelector;
            this.items.push(item);
        },
        removeDocumentFromList(data) {
            this.items = this.items.filter((item) => item.id != data.item.id);
            this.$refs.document_selector.items.splice(0, 0, data.item);
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container {
    max-height: 50rem;
    overflow: auto;
}

@media(max-width: 840px) {
  .table-container {
    max-height: 7rem;
    overflow: auto;
  }
}

.document-table {
  cursor: pointer;
  font-size: 16px;
  thead {
    font-size: 14px;
    tr {
      th {
        background: #f8f8f8 !important;
      }
    }
  }
  tr {
    th, td {
      padding: 0.5rem 0.75rem;
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid $colorBorderDash;
    }
  }
}
</style>